import moment from 'moment-timezone';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import React from 'react';
import { compose, lifecycle, withState } from 'recompose';
import { connect } from 'react-redux';
import SimpleHeader from '../../headers/simpleHeader';
import RetentionReportFilters from './RetentionReportFilters';
import { getShop } from '../../../auth/selectors';
import HeaderDropdown from '../containers/HeaderDropdown';
import { getRetentionTable, getRetentionReportQuarters, getCustomerRetainedVisitsCount } from './selectors';
import Percentage from '../../../common/Percentage';
import withLoading from '../../../common/withLoading';

const RetentionReport = ({ report, quarters, customerRetainedVisitsCount, getCsv, getReport }) => (
  <div>
    <SimpleHeader heading="Retention Report">
      <HeaderDropdown title="Retention Report" />
    </SimpleHeader>
    <div className="c-wrapper o-page-height">
      <RetentionReportFilters
        onChange={getReport}
        quarters={quarters}
        customerRetainedVisitsCount={customerRetainedVisitsCount}
        getCsv={getCsv}
      />
      <ReactTable
        data={report}
        showPagination={false}
        minRows={0}
        defaultPageSize={10000}
        className="c-table c-table-new c-table-with-sticky-header c-table--small c-no-hover u-mt-- u-mb+"
        columns={[
          {
            Header: 'Barber Name',
            accessor: 'name',
            id: 'name',
            className: 'u-text-center',
          },
          {
            Header: 'Existing Customer Retention %',
            accessor: 'existingCustomerRetention',
            id: 'existingCustomerRetention',
            className: 'u-text-center',
            Cell: props => <Percentage>{props.value * 100}</Percentage>,
          },
          {
            Header: 'Total Existing Customers Retained',
            accessor: 'existingCustomersRetainedCount',
            id: 'existingCustomersRetainedCount',
            className: 'u-text-center',
          },
          {
            Header: 'New Customer Retention %',
            accessor: 'newCustomerRetention',
            id: 'newCustomerRetention',
            className: 'u-text-center',
            Cell: props => <Percentage>{props.value * 100}</Percentage>,
          },
          {
            Header: 'Total New Customers Retained',
            accessor: 'newCustomersRetainedCount',
            id: 'newCustomersRetainedCount',
            className: 'u-text-center',
          },
          {
            Header: 'Lost To Another Professional',
            accessor: 'lostToAnotherBarber',
            id: 'lostToAnotherBarber',
            className: 'u-text-center',
          },
        ]}
      />
    </div>
  </div>
);

const mapStateToProps = state => ({
  shop: getShop(state),
  quarters: getRetentionReportQuarters(state),
  customerRetainedVisitsCount: getCustomerRetainedVisitsCount(state),
  report: getRetentionTable(state),
});

RetentionReport.propTypes = {
  report: PropTypes.array,
  quarters: PropTypes.array,
  getReport: PropTypes.func.isRequired,
  customerRetainedVisitsCount: PropTypes.number,
  getCsv: PropTypes.func.isRequired,
};

RetentionReport.defaultProps = {
  report: [],
  quarters: [],
  customerRetainedVisitsCount: 2,
};

export default compose(
  connect(mapStateToProps),
  withState('showLoading', 'setShowLoading', false),
  withLoading,
  lifecycle({
    componentDidMount() {
      const lastQuarter = moment.tz(this.props.timezone).subtract(1, 'quarter');
      this.props.getReport(lastQuarter.quarter(), lastQuarter.year());
    },
  })
)(RetentionReport);
